import { StagesSendFunds } from '@shared/types/frontend/sendFunds';
import { CovalentBalanceItem } from '@shared/types/frontend';
import ImageWithBadge from '../ImageWithBadge';
import ReceiverItemView from '../receiverItemView';
import { toSpecialFixed } from '@/lib/misc/utils';
const VerifyStage = ({
  usdAmount,
  tokenAmount,
  receiver,
  tokenData,
  setStage,
  resetSendTo
}: {
  usdAmount?;
  tokenAmount?;
  receiver;
  tokenData: CovalentBalanceItem;
  setStage: (_: StagesSendFunds) => void;
  resetSendTo: () => void;
}) => {
  return <div className='grid gap-8 px-8' data-sentry-component="VerifyStage" data-sentry-source-file="VerifyStage.tsx">
      <div className='grid gap-4'>
        <p className='opacity-50'>You are sending to</p>
      </div>
      {receiver.username && <ReceiverItemView resetSendTo={resetSendTo} shadow={true} user={receiver} setStage={setStage} />}
      {receiver.address && <ReceiverItemView resetSendTo={resetSendTo} shadow={true} wallet={receiver} setStage={setStage} />}
      <div className='grid gap-2'>
        <div className='flex justify-between'>
          <p className='opacity-50'>Value</p>
          <div className='flex gap-2 items-center'>
            <p>${usdAmount}</p>
          </div>
        </div>
        <div className='flex justify-between'>
          <p className='opacity-50'>Token</p>
          <div className='flex gap-2 items-center'>
            <ImageWithBadge mainImageSrc={tokenData?.logo_urls?.token_logo_url} badgeImageSrc={tokenData?.logo_urls?.chain_logo_url} data-sentry-element="ImageWithBadge" data-sentry-source-file="VerifyStage.tsx" />
            <p>{tokenAmount === 'NaN' ? 0 : toSpecialFixed(tokenAmount).value}</p>
            <div>{tokenData.contract_ticker_symbol}</div>
          </div>
        </div>
      </div>
    </div>;
};
export default VerifyStage;